import BookingFlowSidebar from '~/components/BookingFlow/Sidebar';
import Steps from '~/components/BookingFlow/Steps';
import useTranslation from '~/hooks/useTranslation';
import styles from '~/styles/bookingFlow/booking-flow.module.css';
import sidebarOverviewStyles from '~/styles/bookingFlow/sidebar-overview.module.css';
import cnh from '~/helpers/cnh';
import SidebarPrice from '~/components/BookingFlow/SidebarPrice';
import type { Summary as SummaryType } from '~/types/api';
import Summary from '~/components/BookingFlow/Summary';

type Props = {
  step: number;
  children: React.ReactNode;
  sidebarVisible: boolean;
  showDisclaimer: boolean;
  sidebarActions: React.ReactNode;
  contentActions: React.ReactNode;
  summary?: SummaryType | null;
};

export default function BookingFlowLayout({
  step,
  children,
  sidebarVisible,
  showDisclaimer,
  sidebarActions,
  contentActions,
  summary,
}: Props) {
  const translate = useTranslation();

  return (
    <div className={styles.bookingFlow}>
      <Steps step={step} />

      <div
        className={cnh(styles.bookingFlowRow, sidebarVisible ? styles.bookingFlowRowWithSidebar : '')}
      >
        {sidebarVisible && (
          <BookingFlowSidebar className={styles.bookingFlowSidebar}>
            {summary && (
              <>
                <Summary
                  summary={summary}
                  className={sidebarOverviewStyles.sidebarOverview}
                />

                <SidebarPrice summary={summary} />
              </>
            )}

            {sidebarActions}
          </BookingFlowSidebar>
        )}

        <div className={styles.bookingFlowContent}>
          {children}

          {contentActions}

          <div className={styles.bookingFlowRequired}>
            {`* ${translate('form.required')}`}
          </div>

          {showDisclaimer && (
            <div className={styles.bookingFlowDisclaimer}>
              {`** ${translate('bookingFlow.disclaimer')}`}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
